<template>
  <div class="section1-wrap">
    <div class="section1">
      <div class="section-title">
        <div class="section-title-zh">1.全流程系统</div>
        <div class="section-title-en">FULL FLOW SYSTEM</div>
      </div>
      <div class="section1-content">
        <ul class="step-btn-group">
          <li
            :class="['item-btn', state === 'before' ? 'active' : '']"
            @click="handleSelect('before')"
          >
            检前
          </li>
          <li
            :class="['item-btn', state === 'underway' ? 'active' : '']"
            @click="handleSelect('underway')"
          >
            检中
          </li>
          <li
            :class="['item-btn', state === 'after' ? 'active' : '']"
            @click="handleSelect('after')"
          >
            检后
          </li>
        </ul>
        <!--    检前    -->
        <div class="item-step" v-if="state === 'before'">
          <el-row :gutter="18" style="margin-bottom: 42px">
            <el-col :span="8">
              <div class="item-step-view">
                <div class="view-title">飞碟CDM系统</div>
                <div class="view-content">
                  客户工商信息、设定保护单位、智能设计备单、与体检系统融合、多种体检类型、回款结算管理、智能核算提成
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item-step-view">
                <div class="view-title">预约系统</div>
                <div class="view-content">
                  微信公众号、微信小程序、个人预约、团客预约、个性定制、预约加项、电子报告
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item-step-view">
                <div class="view-title">自助机系统</div>
                <div class="view-content">
                  导检登记、人证匹配、人脸识别、自助操作
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--    检中     -->
        <div class="item-step" v-if="state === 'underway'">
          <el-row gutter="10" style="margin-bottom: 42px">
            <el-col :span="8">
              <div class="item-step-view">
                <div class="view-title">健康体检系统</div>
                <div class="view-content">
                  前台个性操作、前台身份登记、词条库（17年积累）、业务质控模块、客户评价系统、卡券管理系统、运营管理咨询
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item-step-view">
                <div class="view-title">职业病体检系统</div>
                <div class="view-content">
                  团客名单、分组套餐、接害因素、报告管理、汇总模块、一键网报
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item-step-view">
                <div class="view-title">移动外检体检系统</div>
                <div class="view-content">
                  打印条码、导引单、结果录入、报告管理、批量管理、适配无网
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="item-step-view">
                <div class="view-title">智能导检系统</div>
                <div class="view-content">
                  导检进度、智能提示、排队指引、智能推荐、静默加项、支付结算
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--    检后      -->
        <div class="item-step" v-if="state === 'after'">
          <el-row gutter="12" style="margin-bottom: 42px">
            <el-col span="12">
              <div class="item-step-view">
                <div class="view-title">在线报告解读系统</div>
                <div class="view-content">在线一对一报告解读</div>
              </div>
            </el-col>
            <el-col span="12">
              <div class="item-step-view">
                <div class="view-title">在线视频问诊系统</div>
                <div class="view-content">在线一对一视频问诊</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- section2 -->
    <div class="section2-wrap" id="section2">
      <div class="section2">
        <div class="section-title">
          <div class="section-title-zh">2.业务全流程</div>
          <div class="section-title-en">WHOLE BUSINESS PROCESS</div>
        </div>
        <div class="section2-content">
          <img
            src="../../assets/product/step2_img.png"
            alt="img"
            class="step2_img"
          />
        </div>
      </div>
    </div>

    <!-- section3 -->
    <div class="section3-wrap" id="section3">
      <div class="section3">
        <div class="section-title">
          <div class="section-title-zh">3.功能优势</div>
          <div class="section-title-en">FUNCTIONAL ADVANTAGES</div>
        </div>
        <div class="section3-content">
          <div class="item-view">
            <img
              src="../../assets/product/section3_1.png"
              alt="img"
              class="item-view-img"
            />
            <div class="item-view-text">
              <div class="item-view-text-title">全过程体检质控</div>
              <div class="item-view-text-content">
                飞碟基于JCI国际权威的医疗管理标准，以客户为中心，关注质量改进与患者安全，开展覆盖检前、检中、检后全过程的体检质量控制。包括AI智能纠错、项目互斥、审核制度、驳回制度、报告滞留处理、阳性处理、重大危急值管理、历史体检数据对比等质量控制，推动体检机构的学科建设和规范化服务。
              </div>
            </div>
          </div>
          <!--  -->
          <div class="item-view">
            <div class="item-view-text">
              <div class="item-view-text-title">客户评价系统</div>
              <div class="item-view-text-content">
                通过完整的客户评价体系持续提升客户服务体验，提高服务标准，从客户角度完善健康体检中心内部管理流程，控制医疗质量，保证服务体验，助力健康体检中心不断优化完善，提高行业竞争力。
              </div>
            </div>
            <img
              src="../../assets/product/section3_2.png"
              alt="img"
              class="item-view-img"
            />
          </div>
          <!--  -->
          <div class="item-view">
            <img
              src="../../assets/product/section3_3.png"
              alt="img"
              class="item-view-img"
            />
            <div class="item-view-text">
              <div class="item-view-text-title">智能导检</div>
              <div class="item-view-text-content">
                支持手机、iPad、电子屏幕等多终端智能导助实时指引，达到现场秩序可控，提升科室可控率的同时，提升体检者满意度及舒适度，并通过科学化管理实现数据化运营。
              </div>
            </div>
          </div>
          <!--  -->
          <div class="item-view">
            <div class="item-view-text">
              <div class="item-view-text-title">可视化看板</div>
              <div class="item-view-text-content">
                健康体检中心主任及管理人员通过可视化看板，查看人流量、检线、排队情况等，直观了解健康体检中心的运营数据，为管理决策提供重要依据。
              </div>
            </div>
            <img
              src="../../assets/product/section3_4.png"
              alt="img"
              class="item-view-img"
            />
          </div>
          <!--  -->
          <div class="item-view">
            <img
              src="../../assets/product/section3_5.png"
              alt="img"
              class="item-view-img"
            />
            <div class="item-view-text">
              <div class="item-view-text-title">科研数据统计</div>
              <div class="item-view-text-content">
                为满足科研需求，通过对数据源选择合理的统计方法，可进行自定义数据筛选，帮助主任导出科研数据样本，支持统计分析与课题研究工作。
              </div>
            </div>
          </div>
          <!-- 6 -->
          <div class="item-view">
            <div class="item-view-text">
              <div class="item-view-text-title">视频问诊/在线报告解读</div>
              <div class="item-view-text-content">
                可视化、电子化所有的体检报告，专家可直观查看所有体检数据及健康档案，通过互联网一对一在线问诊与报告解读，对体检报告中异常指标进行分析、对医学影像检测结果进行解读，为体检者给出一定的健康建议指导。
              </div>
            </div>
            <img
              src="../../assets/product/section3_6.png"
              alt="img"
              class="item-view-img"
            />
          </div>
          <!-- 7 -->
          <div class="item-view">
            <img
              src="../../assets/product/section3_7.png"
              alt="img"
              class="item-view-img"
            />
            <div class="item-view-text">
              <div class="item-view-text-title">CDM客户管理</div>
              <div class="item-view-text-content">
                实现团客订单管理，或更细致的客户关系管理。以数据收集、存储、分析等功能驱动客户、销售和财务三大板块，支撑客户全生命周期管理，为客户打通完整的价值链条，助力健康体检中心互联时代下业绩的规模化增长。
              </div>
            </div>
          </div>
          <!-- 8 -->
          <div class="item-view">
            <div class="item-view-text">
              <div class="item-view-text-title">总检原版阅片</div>
              <div class="item-view-text-content">
                支持总检医师可针对DR、CT、核磁、乳腺X线摄影等原版影像资料查阅。
              </div>
            </div>
            <img
              src="../../assets/product/section3_8.png"
              alt="img"
              class="item-view-img"
            />
          </div>
          <!-- 9 -->
          <div class="item-view">
            <img
              src="../../assets/product/section3_9.png"
              alt="img"
              class="item-view-img"
            />
            <div class="item-view-text">
              <div class="item-view-text-title">分院管理集中阅片</div>
              <div class="item-view-text-content">
                支持单院区、多院区不同模式的管理，由各分院区上传数据至总院区，集中阅片、汇总总检，真正实现集中化管理。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "productItem1",
  data() {
    return {
      state: "before",
    };
  },
  methods: {
    handleSelect(state) {
      this.state = state;
    },
  },
};
</script>
<style scoped lang="less">
.section-title {
  position: relative;
  height: 74px;
  .section-title-zh {
    z-index: 9;
    width: 100%;
    position: absolute;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5680b9;
    text-align: center;
  }
  .section-title-en {
    width: 100%;
    position: absolute;
    font-size: 50px;
    font-family: MiSans;
    font-weight: 400;
    color: #f5f5f5;
    text-align: center;
  }
}
.section1-wrap {
  width: 100%;

  .section1 {
    width: 1200px;
    margin: 0 auto;
    padding-top: 100px;
    padding-bottom: 100px;
    // 分步 按钮组
    .step-btn-group {
      list-style-type: none;
      display: flex;
      border-bottom: 1px solid #3580ff;
      margin-bottom: 66px;
      width: 638px;
      .item-btn {
        width: 208px;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999999;
        font-size: 24px;
      }
      .item-btn:hover {
        cursor: pointer;
      }
      .active {
        background: url("../../assets/product/step_bg.png") no-repeat;
        background-size: 100% 100%;
        color: #fff;
      }
    }
    // 分步 内容
    .item-step {
      display: flex;
      flex-wrap: wrap;
      .item-step-view {
        width: 386px;
        height: 242px;
        background: #f7f7f7;
        border-radius: 20px;
        padding-top: 50px;
        padding-left: 36px;
        padding-right: 36px;
        box-sizing: border-box;
        .view-title {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          text-align: center;
          margin-bottom: 36px;
        }
        .view-content {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 2;
        }
      }
    }
  }
  // section2
  .section2-wrap {
    width: 100%;
    background: #fafafa;
    .section2 {
      padding: 88px 0;
      .section2-content {
        text-align: center;
        .step2_img {
          margin: 88px auto;
          width: 1054px;
        }
      }
    }
  }
  // section3
  .section3-wrap {
    width: 100%;
    background: #fff;
    .section3 {
      padding: 100px 0;

      .section3-content {
        width: 1200px;
        margin: 0 auto;
        .item-view {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 80px;
          .item-view-img {
            width: 570px;
          }
          .item-view-text {
            width: 495px;
            .item-view-text-title {
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              margin-bottom: 28px;
            }
            .item-view-text-content {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 2;
            }
          }
        }
      }
    }
  }
}
</style>
